import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.cover}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-white text-xs font-medium rounded-full mb-6 whitespace-nowrap">
          热门推荐
        </span>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 max-w-3xl">
          {banner.title}
        </h1>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl">
          {banner.subtitle}
        </p>
        <Link
          to={`/comic/${banner.comicId}`}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer"
        >
          立即阅读
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-white scale-110' : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => setCurrent((prev) => (prev - 1 + banners.length) % banners.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-all z-10 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-white text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-all z-10 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-white text-lg md:text-xl"></i>
      </button>
    </section>
  );
}